import * as React from "react"
import { CurrentUserProvider } from "./src/hooks/CurrentUserProvider"
import "./src/reset.css"
import "./src/material.css"

export const wrapRootElement = ({ element }) => {
  return <CurrentUserProvider>{element}</CurrentUserProvider>
}
